import React from 'react';
import { IconProps } from './types';

const LinkThin: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2931 1.66415C15.4101 0.781136 14.2554 0.305664 13.0328 0.305664C11.8101 0.305664 10.6554 0.781136 9.77239 1.66415L7.08937 4.34717C6.8856 4.55095 6.8856 4.85661 7.08937 5.06038C7.29314 5.26415 7.5988 5.26415 7.80258 5.06038L10.4856 2.37736C11.1648 1.69812 12.0818 1.32453 13.0328 1.32453C13.9837 1.32453 14.9007 1.69812 15.5799 2.37736C16.2592 3.05661 16.6328 3.97359 16.6328 4.92453C16.6328 5.87548 16.2252 6.79246 15.546 7.4717L12.863 10.1547C11.4705 11.5472 9.19503 11.5472 7.80258 10.1547C7.42899 9.78114 7.15729 9.33963 6.95352 8.83019C6.85163 8.55849 6.57994 8.42265 6.30824 8.52453C6.03654 8.62642 5.90069 8.89812 6.00258 9.16982C6.24031 9.8151 6.57994 10.3925 7.08937 10.8679C7.97239 11.7509 9.16107 12.2264 10.3497 12.2264C11.5384 12.2264 12.7271 11.7849 13.6101 10.8679L16.2931 8.18491C17.1762 7.30189 17.6516 6.14717 17.6516 4.92453C17.6516 3.70189 17.1422 2.54717 16.2931 1.66415Z"
      fill={!ignoreColor ? color : undefined}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.77264 13.2453L7.08962 15.9283C5.69717 17.3208 3.4217 17.3208 2.02925 15.9283C1.35 15.2491 0.976415 14.3321 0.976415 13.3811C0.976415 12.4302 1.35 11.5132 2.02925 10.834L4.71226 8.15095C5.39151 7.47171 6.30849 7.09812 7.25943 7.09812C8.21038 7.09812 9.12736 7.47171 9.8066 8.15095C10.1123 8.45661 10.35 8.8302 10.5538 9.20378C10.6557 9.47548 10.9613 9.57737 11.233 9.47548C11.5047 9.37359 11.6066 9.06793 11.5047 8.79624C11.267 8.2868 10.9613 7.84529 10.5538 7.43774C9.67076 6.55473 8.51604 6.07925 7.2934 6.07925C6.07075 6.07925 4.91604 6.55473 4.03302 7.43774L1.35 10.1208C-0.45 11.9208 -0.45 14.8415 1.35 16.6415C2.23302 17.5245 3.4217 18 4.61038 18C5.79906 18 6.98774 17.5585 7.87075 16.6415L10.5538 13.9585C10.7575 13.7547 10.7575 13.4491 10.5538 13.2453C10.35 13.0415 9.97641 13.0415 9.77264 13.2453Z"
      fill={!ignoreColor ? color : undefined}
    />
  </svg>
);

export default LinkThin;
